import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Spin,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import dayjs from "dayjs";
import {
  fetchCoBranch,
  fetchCountry,
  fetchDepts,
  fetchGender,
  fetchPayrollType,
  fetchSections,
  fetchStaffCategory,
  fetchStaffGrade,
  fetchStaffPositionByGrade,
  fetchStaffStatus,
  fetchStaffTerm,
} from "../../features/dropdown/dropdownSlice";
import { save } from "../../features/save/saveSlice";
import { setFolderObj, setRefetchKey } from "../../features/folder/folderSlice";
import { normalizeDateToLocalYear } from "../../utils";

const { TextArea } = Input;
function PersonnelAdd({ setactive }) {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { user } = useSelector((state) => state.auth);
  const {
    countryData,
    genderData,
    staffStatus,
    staffGradeData,
    staffPositionByGrade,
    staffTerm,
    staffCategory,
    payrollType,
    coBranch,
    depts,
    sections,
    loading,
  } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const { fldLoading, singlePersonnel, folderObj } = useSelector(
    (state) => state.folder
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState();

  const today = new Date();
  let dd = String(today.getDate()).padStart(2, 0);
  let mm = String(today.getMonth() + 1).padStart(2, 0);
  let yyyy = today.getFullYear() - 18;

  let minDate = `${yyyy}-${mm}-${dd}`;

  function handleSelectChange(value, formName) {
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const [data, setdata] = useState({});

  const handleNumberChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      chTelephone: String(e),
    }));
  };

  useEffect(() => {
    setFormData();
  }, []);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  function onMonthChange(value) {
    setFormData((prevData) => ({
      ...prevData,
      ppDob: value,
    }));
  }

  const handleCancel = async (e) => {
    navigate(-1);
  };
  const [gradeId, setGradeId] = useState();
  const [deptId, setDeptId] = useState();

  async function fetchStaffPositionByGradeData() {
    await dispatch(
      fetchStaffPositionByGrade({
        sgId_id: gradeId,
      })
    );
  }
  async function fetchSectionsData() {
    await dispatch(
      fetchSections({
        coDeptid_id: deptId,
      })
    );
  }

  useEffect(() => {
    fetchStaffPositionByGradeData();
    fetchSectionsData();
  }, []);

  async function fetchCountryData() {
    await dispatch(fetchCountry());
  }
  async function fetchGenderData() {
    await dispatch(fetchGender());
  }
  async function fetchStaffGradeData() {
    await dispatch(fetchStaffGrade());
  }
  async function fetchStaffTermData() {
    await dispatch(fetchStaffTerm());
  }
  async function fetchStaffCategoryData() {
    await dispatch(fetchStaffCategory());
  }
  async function fetchPayrollTypeData() {
    await dispatch(fetchPayrollType());
  }
  async function fetchCoBranchData() {
    await dispatch(fetchCoBranch());
  }
  async function fetchDeptsData() {
    await dispatch(fetchDepts());
  }
  async function fetchStaffStatusData() {
    await dispatch(fetchStaffStatus());
  }

  const [value, setValue] = useState(
    folderObj?.hasDailyRate == null
      ? 0
      : folderObj?.hasDailyRate === false
      ? 0
      : folderObj?.hasDailyRate === true
      ? 1
      : 0
  );

  const onChangeCheckbox = (e) => {
    if (e.target.checked) {
      setValue(1);
    } else {
      setValue(0);
    }
  };

  const onFinish = async (data) => {
    data.ppCellphone = data?.ppTelephone;
    data.ppFullname = [data.ppFirstname, data.ppMiddlename, data.ppLastname]
      .filter(Boolean)
      .join(" ");
    data.ppId = folderObj?.ppId ? folderObj?.ppId : null;
    data.ppDob = normalizeDateToLocalYear(data?.ppDob);
    data.ppStartdate = normalizeDateToLocalYear(data?.ppStartdate);
    data.ppEnddate = normalizeDateToLocalYear(data?.ppEnddate);
    const res = await dispatch(
      save({
        url: `hr/savePersonnel.action?hasDailyRate=${value}`,
        ...data,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await dispatch(setFolderObj(res?.payload?.data?.result?.[0]));
      await setactive("2");
      await dispatch(setRefetchKey("2"));
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const initialFormValues = {
    ...folderObj,
    ppDob: folderObj?.ppDob
      ? dayjs(folderObj?.ppDob)
      : data?.ppDob
      ? dayjs(data?.ppDob)
      : null,
    ppEnddate: folderObj?.ppEnddate
      ? dayjs(folderObj?.ppEnddate)
      : data?.ppEnddate
      ? dayjs(data?.ppEnddate)
      : null,
    ppStartdate: folderObj?.ppStartdate
      ? dayjs(folderObj?.ppStartdate)
      : data?.ppStartdate
      ? dayjs(data?.ppStartdate)
      : null,
    ppInactivedDate: folderObj?.ppInactivedDate
      ? dayjs(folderObj?.ppInactivedDate)
      : data?.ppInactivedDate
      ? dayjs(data?.ppInactivedDate)
      : null,
    ppTelephone: folderObj?.ppTelephone
      ? folderObj.ppTelephone.startsWith("07")
        ? `+254${folderObj?.ppTelephone?.slice(1)}`
        : folderObj?.ppTelephone
      : data?.ppTelephone?.startsWith("07")
      ? `+254${data?.ppTelephone?.slice(1)}`
      : data?.ppTelephone || null,
  };
  // form.setFieldsValue({ invAptId: allApartmentIds });
  useEffect(() => {
    setValue(
      folderObj?.hasDailyRate == null
        ? 0
        : folderObj?.hasDailyRate === false
        ? 0
        : folderObj?.hasDailyRate === true
        ? 1
        : 0
    );
  }, [folderObj]);

  useEffect(() => {
    fetchCountryData();
    fetchGenderData();
    fetchStaffGradeData();
    fetchStaffTermData();
    fetchStaffCategoryData();
    fetchPayrollTypeData();
    fetchCoBranchData();
    fetchDeptsData();
    fetchStaffStatusData();
  }, []);

  return (
    <>
      <div className="">
        <div className="flex  ">
          <div className="w-full lg:w-[61.25rem]">
            <div className="flex flex-col w-full ">
              <Form
                layout="vertical"
                ref={formRef}
                name="control-ref"
                onFinish={onFinish}
                style={{
                  maxWidth: "100%",
                }}
                initialValues={initialFormValues}
                // onValuesChange={handleValuesChange}
                form={form}
              >
                <div className="mt-[2rem] p-3 !pr-0 lg:!pr-10 lg:p-0 py-[.5rem] flex flex-col justify-center w-full rounded-[.5625rem]">
                  <div className="my-[.25rem] px-[1.37rem] flex flex-col items-start justify-start ">
                    <div className="flex items-center gap-x-5">
                      <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
                        <span className="paragraph_paragraph_bb08">1</span>
                      </div>
                      <span className="paragraph_paragraph_bb13">
                        Personal Details
                      </span>
                    </div>

                    <div className="w-full flex flex-col ml-[5rem]">
                      <Form.Item
                        className="table-form-item"
                        name="ppPfno"
                        label="Personnel No"
                        rules={[
                          {
                            required: true,
                            message: "Please add personnel No",
                          },
                        ]}
                      >
                        <Input className="input" />
                      </Form.Item>

                      <div className="grid grid-cols-1 lg:grid-cols-2 pb-[2.5rem] gap-x-[1.25rem] w-full">
                        <Form.Item
                          className="table-form-item"
                          name="ppFirstname"
                          label="First Name"
                          rules={[
                            {
                              required: true,
                              message: "Please add first name",
                            },
                          ]}
                        >
                          <Input className="input" />
                        </Form.Item>

                        <Form.Item
                          className="table-form-item"
                          name="ppMiddlename"
                          label="Middle Name"
                          rules={[
                            {
                              required: true,
                              message: "Please add middle name",
                            },
                          ]}
                        >
                          <Input className="input" />
                        </Form.Item>

                        <Form.Item
                          className="table-form-item"
                          name="ppLastname"
                          label="Last Name"
                          rules={[
                            {
                              required: true,
                              message: "Please add last name",
                            },
                          ]}
                        >
                          <Input className="input" />
                        </Form.Item>

                        <Form.Item
                          rules={[
                            {
                              required: false,
                              message: "Field is required",
                            },
                          ]}
                          name="ppDob"
                          label="Date of Birth"
                        >
                          <DatePicker
                            maxDate={dayjs(minDate)}
                            className="input"
                          />
                        </Form.Item>

                        <Form.Item
                          name="gdId"
                          className=""
                          label={<span>Gender</span>}
                          rules={[
                            {
                              required: true,
                              message: "Please select gender",
                            },
                          ]}
                        >
                          <Select
                            className=""
                            allowClear
                            style={{
                              width: "100%",
                            }}
                            options={
                              genderData?.length > 0 &&
                              genderData?.map((item) => ({
                                value: item?.gdId,
                                label: item?.gdName,
                              }))
                            }
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (
                                option?.label?.toLocaleLowerCase() ?? ""
                              ).includes(input?.toLocaleLowerCase())
                            }
                            // onDropdownVisibleChange={() => {
                            //   fetchGenderData();
                            // }}
                            dropdownRender={(menu) => (
                              <>
                                {loading && (
                                  <div
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Spin className="sms-spin" />
                                  </div>
                                )}
                                {menu}
                              </>
                            )}
                          />
                        </Form.Item>

                        <Form.Item
                          name="couId"
                          className=""
                          label={<span>Select Country</span>}
                          rules={[
                            {
                              required: true,
                              message: "Please select sender name",
                            },
                          ]}
                        >
                          <Select
                            className=""
                            allowClear
                            style={{
                              width: "100%",
                            }}
                            options={
                              countryData?.length > 0 &&
                              countryData?.map((item) => ({
                                value: item?.couId,
                                label: item?.couName,
                              }))
                            }
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (
                                option?.label?.toLocaleLowerCase() ?? ""
                              ).includes(input?.toLocaleLowerCase())
                            }
                            // onDropdownVisibleChange={() => {
                            //   fetchCountryData();
                            // }}
                            dropdownRender={(menu) => (
                              <>
                                {loading && (
                                  <div
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Spin className="sms-spin" />
                                  </div>
                                )}
                                {menu}
                              </>
                            )}
                          />
                        </Form.Item>

                        <Form.Item
                          className="table-form-item"
                          name="ppNationalid"
                          label="National ID"
                          rules={[
                            {
                              required: true,
                              message: "Please add national ID",
                            },
                          ]}
                        >
                          <InputNumber
                            min={0}
                            formatter={(value) => value}
                            parser={(value) =>
                              value?.replace(/\$\s?|(,*)/g, "")
                            }
                            placeholder="Enter national ID"
                            className="input flex"
                          />
                        </Form.Item>

                        <Form.Item
                          className="table-form-item"
                          name="ppPassportno"
                          label="Passport Number"
                          rules={[
                            {
                              required: true,
                              message: "Please add passport number",
                            },
                          ]}
                        >
                          <InputNumber
                            min={0}
                            formatter={(value) => value}
                            parser={(value) =>
                              value?.replace(/\$\s?|(,*)/g, "")
                            }
                            placeholder="Enter passport number"
                            className="input flex"
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>

                <div className=" p-3 !pr-0 lg:!pr-10 lg:p-0 py-[.5rem] flex flex-col justify-center w-full rounded-[.5625rem]">
                  <div className="my-[.25rem] px-[1.37rem] flex flex-col items-start justify-start ">
                    <div className="flex items-center gap-x-5">
                      <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
                        <span className="paragraph_paragraph_bb08">2</span>
                      </div>
                      <span className="paragraph_paragraph_bb13">
                        Contact Details
                      </span>
                    </div>

                    <div className="w-full flex flex-col ml-[5rem]">
                      <div className="grid grid-cols-1 lg:grid-cols-2 pb-[2.5rem] gap-x-[1.25rem] w-full">
                        <Form.Item
                          className="table-form-item"
                          name="ppPostaladdr"
                          label="Postal Address"
                          rules={[
                            {
                              required: true,
                              message: "Please add postal address",
                            },
                          ]}
                        >
                          <Input className="input" />
                        </Form.Item>
                        <Form.Item
                          className="table-form-item"
                          name="ppPostalcode"
                          label="Postal Code"
                          rules={[
                            {
                              required: true,
                              message: "Please add postal code",
                            },
                          ]}
                        >
                          <Input className="input" />
                        </Form.Item>

                        <Form.Item
                          className="table-form-item"
                          name="ppPhysicaladdr"
                          label="Physical Address"
                          rules={[
                            {
                              required: true,
                              message: "Please add physical address",
                            },
                          ]}
                        >
                          <Input className="input" />
                        </Form.Item>

                        <Form.Item
                          className="table-form-item"
                          name="ppTelephone"
                          label="Office Phone No"
                          rules={[
                            {
                              required: true,
                              message: "Please add office phone no",
                            },
                            {
                              validator: (_, value) => {
                                if (value && value.length === 12) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(
                                  new Error(
                                    "Phone number must be exactly 10 characters"
                                  )
                                );
                              },
                            },
                          ]}
                        >
                          <PhoneInput
                            country="ke"
                            countryCodeEditable={false}
                            className="input"
                          />
                        </Form.Item>

                        <Form.Item
                          className="table-form-item"
                          name="ppEmail"
                          label="Official Email Address"
                          rules={[
                            {
                              required: true,
                              message: "Please add official email address",
                            },
                            {
                              type: "email",
                              message: "Please enter a valid email address",
                            },
                          ]}
                        >
                          <Input type="email" className="input" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-3 !pr-0 lg:!pr-10 lg:p-0 py-[.5rem] flex flex-col justify-center w-full rounded-[.5625rem]">
                  <div className="my-[.25rem] px-[1.37rem] flex flex-col items-start justify-start ">
                    <div className="flex items-center gap-x-5">
                      <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
                        <span className="paragraph_paragraph_bb08">3</span>
                      </div>
                      <span className="paragraph_paragraph_bb13">
                        Employment Details
                      </span>
                    </div>

                    <div className="w-full flex flex-col ml-[5rem]">
                      <div className="grid grid-cols-1 lg:grid-cols-2 pb-[2.5rem] gap-x-[1.25rem] w-full">
                        <Form.Item
                          name="ssId"
                          className=""
                          label="Staff Status"
                          rules={[
                            {
                              required: true,
                              message: "Please select staff status",
                            },
                          ]}
                        >
                          <Select
                            className=""
                            allowClear
                            style={{
                              width: "100%",
                            }}
                            options={
                              staffStatus?.length > 0 &&
                              staffStatus?.map((item) => ({
                                value: item?.ssId,
                                label: item?.ssStatusname,
                              }))
                            }
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (
                                option?.label?.toLocaleLowerCase() ?? ""
                              ).includes(input?.toLocaleLowerCase())
                            }
                            // onDropdownVisibleChange={() => {
                            //   fetchStaffStatusData();
                            // }}
                            dropdownRender={(menu) => (
                              <>
                                {loading && (
                                  <div
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Spin className="sms-spin" />
                                  </div>
                                )}
                                {menu}
                              </>
                            )}
                          />
                        </Form.Item>
                        {(folderObj?.ppInactivedDate  && folderObj?.ssStatusname == "Inactive") && (
                          <Form.Item
                            rules={[
                              {
                                required: false,
                                message: "Inactivated date is required",
                              },
                            ]}
                            name="ppInactivedDate"
                            label="Inactivated Date"
                          >
                            <DatePicker disabled={true} className="input" />
                          </Form.Item>
                        )}

                        <Form.Item
                          rules={[
                            {
                              required: false,
                              message: "Employeement Date is required",
                            },
                          ]}
                          name="ppStartdate"
                          label="Employeement Date"
                        >
                          <DatePicker className="input" />
                        </Form.Item>

                        <Form.Item
                          rules={[
                            {
                              required: false,
                              message: "contract end date is required",
                            },
                          ]}
                          name="ppEnddate"
                          label="Contract End Date"
                        >
                          <DatePicker className="input" />
                        </Form.Item>

                        <Form.Item
                          name="sgId"
                          className=""
                          label={<span>Staff Grade</span>}
                          rules={[
                            {
                              required: true,
                              message: "Please select staff grade",
                            },
                          ]}
                        >
                          <Select
                            className=""
                            allowClear
                            style={{
                              width: "100%",
                            }}
                            options={
                              staffGradeData?.length > 0 &&
                              staffGradeData?.map((item) => ({
                                value: item?.sgId,
                                label: item?.sgGradename,
                              }))
                            }
                            onChange={(value) => {
                              setGradeId(value);
                            }}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (
                                option?.label?.toLocaleLowerCase() ?? ""
                              ).includes(input?.toLocaleLowerCase())
                            }
                            // onDropdownVisibleChange={() => {
                            //   fetchStaffGradeData();
                            // }}
                            dropdownRender={(menu) => (
                              <>
                                {loading && (
                                  <div
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Spin className="sms-spin" />
                                  </div>
                                )}
                                {menu}
                              </>
                            )}
                          />
                        </Form.Item>

                        <Form.Item
                          name="spId"
                          className=""
                          label={<span>Position</span>}
                          rules={[
                            {
                              required: true,
                              message: "Please select position",
                            },
                          ]}
                        >
                          <Select
                            className=""
                            allowClear
                            style={{
                              width: "100%",
                            }}
                            options={
                              staffPositionByGrade?.length > 0 &&
                              staffPositionByGrade?.map((item) => ({
                                value: item?.spId,
                                label: item?.spPositionname,
                              }))
                            }
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (
                                option?.label?.toLocaleLowerCase() ?? ""
                              ).includes(input?.toLocaleLowerCase())
                            }
                            onDropdownVisibleChange={() => {
                              fetchStaffPositionByGradeData();
                            }}
                            dropdownRender={(menu) => (
                              <>
                                {loading && (
                                  <div
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Spin className="sms-spin" />
                                  </div>
                                )}
                                {menu}
                              </>
                            )}
                          />
                        </Form.Item>

                        <Form.Item
                          name="stId"
                          className=""
                          label={<span>Engagement Term</span>}
                          rules={[
                            {
                              required: true,
                              message: "Please select engagement term",
                            },
                          ]}
                        >
                          <Select
                            className=""
                            allowClear
                            style={{
                              width: "100%",
                            }}
                            options={
                              staffTerm?.length > 0 &&
                              staffTerm?.map((item) => ({
                                value: item?.stId,
                                label: item?.stEngtrmname,
                              }))
                            }
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (
                                option?.label?.toLocaleLowerCase() ?? ""
                              ).includes(input?.toLocaleLowerCase())
                            }
                            // onDropdownVisibleChange={() => {
                            //   fetchStaffTermData();
                            // }}
                            dropdownRender={(menu) => (
                              <>
                                {loading && (
                                  <div
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Spin className="sms-spin" />
                                  </div>
                                )}
                                {menu}
                              </>
                            )}
                          />
                        </Form.Item>

                        <Form.Item
                          name="scId"
                          className=""
                          label={<span>Category</span>}
                          rules={[
                            {
                              required: true,
                              message: "Please select category",
                            },
                          ]}
                        >
                          <Select
                            className=""
                            allowClear
                            style={{
                              width: "100%",
                            }}
                            options={
                              staffCategory?.length > 0 &&
                              staffCategory?.map((item) => ({
                                value: item?.scId,
                                label: item?.scCategoryname,
                              }))
                            }
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (
                                option?.label?.toLocaleLowerCase() ?? ""
                              ).includes(input?.toLocaleLowerCase())
                            }
                            // onDropdownVisibleChange={() => {
                            //   fetchStaffCategoryData();
                            // }}
                            dropdownRender={(menu) => (
                              <>
                                {loading && (
                                  <div
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Spin className="sms-spin" />
                                  </div>
                                )}
                                {menu}
                              </>
                            )}
                          />
                        </Form.Item>

                        <Form.Item
                          name="ptId"
                          className=""
                          label={<span>Payroll Type</span>}
                          rules={[
                            {
                              required: true,
                              message: "Please select payroll type",
                            },
                          ]}
                        >
                          <Select
                            className=""
                            allowClear
                            style={{
                              width: "100%",
                            }}
                            options={
                              payrollType?.length > 0 &&
                              payrollType?.map((item) => ({
                                value: item?.ptId,
                                label: item?.ptName,
                              }))
                            }
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (
                                option?.label?.toLocaleLowerCase() ?? ""
                              ).includes(input?.toLocaleLowerCase())
                            }
                            // onDropdownVisibleChange={() => {
                            //   fetchPayrollTypeData();
                            // }}
                            dropdownRender={(menu) => (
                              <>
                                {loading && (
                                  <div
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Spin className="sms-spin" />
                                  </div>
                                )}
                                {menu}
                              </>
                            )}
                          />
                        </Form.Item>

                        <Form.Item
                          name="coBranchid"
                          className=""
                          label={<span>Branch</span>}
                          rules={[
                            {
                              required: true,
                              message: "Please select branch",
                            },
                          ]}
                        >
                          <Select
                            className=""
                            allowClear
                            style={{
                              width: "100%",
                            }}
                            options={
                              coBranch?.length > 0 &&
                              coBranch?.map((item) => ({
                                value: item?.coBranchid,
                                label: item?.coBranchname,
                              }))
                            }
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (
                                option?.label?.toLocaleLowerCase() ?? ""
                              ).includes(input?.toLocaleLowerCase())
                            }
                            // onDropdownVisibleChange={() => {
                            //   fetchCoBranchData();
                            // }}
                            dropdownRender={(menu) => (
                              <>
                                {loading && (
                                  <div
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Spin className="sms-spin" />
                                  </div>
                                )}
                                {menu}
                              </>
                            )}
                          />
                        </Form.Item>

                        <Form.Item
                          name="coDeptid"
                          className=""
                          label={<span>Department</span>}
                          rules={[
                            {
                              required: true,
                              message: "Please select department",
                            },
                          ]}
                        >
                          <Select
                            className=""
                            allowClear
                            style={{
                              width: "100%",
                            }}
                            options={
                              depts?.length > 0 &&
                              depts?.map((item) => ({
                                value: item?.coDeptid,
                                label: item?.coDeptname,
                              }))
                            }
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (
                                option?.label?.toLocaleLowerCase() ?? ""
                              ).includes(input?.toLocaleLowerCase())
                            }
                            // onDropdownVisibleChange={() => {
                            //   fetchDeptsData();
                            // }}
                            onChange={(value) => {
                              setDeptId(value);
                            }}
                            dropdownRender={(menu) => (
                              <>
                                {loading && (
                                  <div
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Spin className="sms-spin" />
                                  </div>
                                )}
                                {menu}
                              </>
                            )}
                          />
                        </Form.Item>

                        <Form.Item
                          name="coSectionid"
                          className=""
                          label={<span>Section</span>}
                          rules={[
                            {
                              required: true,
                              message: "Please select section",
                            },
                          ]}
                        >
                          <Select
                            className=""
                            allowClear
                            style={{
                              width: "100%",
                            }}
                            options={
                              sections?.length > 0 &&
                              sections?.map((item) => ({
                                value: item?.coSectionid,
                                label: item?.coSectionname,
                              }))
                            }
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (
                                option?.label?.toLocaleLowerCase() ?? ""
                              ).includes(input?.toLocaleLowerCase())
                            }
                            onDropdownVisibleChange={() => {
                              fetchSectionsData();
                            }}
                            dropdownRender={(menu) => (
                              <>
                                {loading && (
                                  <div
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Spin className="sms-spin" />
                                  </div>
                                )}
                                {menu}
                              </>
                            )}
                          />
                        </Form.Item>

                        <Form.Item
                          className="table-form-item"
                          name="ppPinno"
                          label="KRA PIN"
                          rules={[
                            {
                              required: false,
                              message: "Please add KRA pin",
                            },
                            {
                              validator: (_, value) => {
                                if (!value) {
                                  return Promise.resolve();
                                }
                                const isValid = /^[A-Z0-9]{11}$/.test(value);
                                return isValid
                                  ? Promise.resolve()
                                  : Promise.reject(
                                      "Invalid Kra Pin format. A valid Kra Pin should be 11 alphanumeric characters."
                                    );
                              },
                            },
                          ]}
                        >
                          <Input className="input" />
                        </Form.Item>

                        <Form.Item
                          className="table-form-item"
                          name="ppNhifno"
                          label="NHIF No"
                          rules={[
                            {
                              required: true,
                              message: "Please add NHIF no",
                            },
                          ]}
                        >
                          <Input className="input" />
                        </Form.Item>

                        <Form.Item
                          className="table-form-item"
                          name="ppNssfno"
                          label="NSSF No"
                          rules={[
                            {
                              required: true,
                              message: "Please add NSSF no",
                            },
                          ]}
                        >
                          <Input className="input" />
                        </Form.Item>

                        <Form.Item
                          label="Has Daily Rate"
                          rules={[
                            {
                              required: false,
                              message: "Enter Has Daily Rate",
                            },
                          ]}
                        >
                          <Checkbox
                            name="hasDailyRate"
                            checked={value}
                            onChange={onChangeCheckbox}
                          >
                            Has Daily Rate
                          </Checkbox>
                        </Form.Item>

                        <Form.Item
                          name="dailyRate"
                          label="Daily Rate"
                          rules={[
                            {
                              required: false,
                              message: "Enter Daily Rate",
                            },
                          ]}
                        >
                          <InputNumber
                            parser={(value) =>
                              value?.replace(/\$\s?|(,*)/g, "")
                            }
                            className="input flex"
                          />
                        </Form.Item>

                        <Form.Item
                          name="workedOffRate"
                          label="Worked Off Rate"
                          rules={[
                            {
                              required: false,
                              message: "Enter Worked Off Rate",
                            },
                          ]}
                        >
                          <InputNumber
                            parser={(value) =>
                              value?.replace(/\$\s?|(,*)/g, "")
                            }
                            className="input flex"
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex justify-center flex-col text-center mt-1 mb-20 gap-y-2 items-center">
                  <div className="w-[200px]">
                    <button
                      key="submit"
                      type="submit"
                      className="cstm-btn"
                      disabled={saving}
                    >
                      {saving ? <Spin /> : "Save"}
                    </button>
                  </div>
                  <div className="w-[200px]">
                    <button
                      onClick={() => navigate(-1)}
                      key="back"
                      type="button"
                      className="cstm-btn !bg-white !text-black1 !border !border-black1"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PersonnelAdd;
